exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero-box-title[data-v-339783c0]{font-size:20px;font-weight:700;line-height:35px;margin-bottom:10px;@media screen and (max-width:768px){font-size:26px}}.border-radius-10[data-v-339783c0]{border-radius:10px}.p-0[data-v-339783c0]{padding:0}.justify-content-between[data-v-339783c0]{-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important}.mr-3[data-v-339783c0]{margin-right:3rem}.max-w-images-banner[data-v-339783c0]{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-339783c0","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/HeroBox.vue
// module id = qaXo
// module chunks = 1